export default __webpack_public_path__ + "static/media/audio.2df4d963.svg";